import { FC, useEffect, useRef, useState } from 'react';
import './SingleMaterialCard.scss';
import { useAppSelector } from '../../redux/app/hooks';
import { MATERIALS_TEXT, MYLIBRARY_TEXTS, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';
import images from '../../assets/images';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import MaterialActionsOverlay from '../ActionsOverlay/MaterialActionsOverlay';
import { materialsData } from '../../utils/interface';
import { BY_ADMIN, getMenuItems } from '../../utils/helper';
import { Tooltip } from '@mui/material';

interface SingleMaterialCardProps {
  material: string,
  keyValue: string,
  navigateLocation?: string,
  state?: string,
  handleOpenFile?: any,
  isQuestionBank?:boolean,
  materialData?: materialsData,
  handleMaterialActions?: (data:materialsData,action:string) => void;
  active? : boolean
}

const SingleMaterialCard: FC<SingleMaterialCardProps> = ({ material, keyValue, navigateLocation, state, handleOpenFile, materialData, handleMaterialActions, isQuestionBank, active}) => {
  const role = useAppSelector((state) => state.auth.role);
  const { ShareIcon, ShareGif, greyMoreIcon, DeleteGif, redDotImage } = images;
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [openOverlay, setOpenOverlay] = useState<boolean>(false);
  const [selectedMaterial, setSelectedMaterial] = useState<materialsData | null>(null);
  const [action, setAction] = useState<string>('');
  const confirmationMessageShare = role === SCHOOL_ADMIN ?  "Are you sure you want to Share this file with your Class & Teacher?": "Are you sure you want to Share this file with your Class?"
  const confirmationMessageDelete = role === SCHOOL_ADMIN ?  "Are you sure you want to Delete this file?": "Are you sure you want to Delete this file with your Class?"

  const materialTitleRef = useRef<HTMLDivElement | null>(null);
     const [isOverflow, setIsOverflow] = useState(false);
  
  
       //To check the container is overflow
    const checkOverflow = () => {
     if (materialTitleRef.current) {
       setIsOverflow(materialTitleRef.current.scrollHeight > materialTitleRef.current.clientHeight);
     }
   };
   
  const navigate = useNavigate();

  const conditionalMaterialName = () => {
    if (material === MATERIALS_TEXT) {
      if(role === SCHOOL_ADMIN){
         return `Learning ${material}`
      }
      else  if (role === TEACHER_ROLE) {
        return `My Teaching ${material}`;
      } else {
        return `My Learning ${material}`;
      }
    } else if(material === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT){
        return `${material}lines`;
    }else{
      return material;
    }
  }

  const handleClick = () => {
          console.log(navigateLocation, "navigate", handleOpenFile)
    if (navigateLocation) {
      console.log(navigateLocation)
      navigate(navigateLocation, {
        state
      });
    } else if (handleOpenFile) {
      handleOpenFile(materialData);
    }
  }

  // click yes button in confirmation popup
  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    if (selectedMaterial && handleMaterialActions) {
      handleMaterialActions(selectedMaterial, action)
    }
  }

  // click no button in confirmation popup
  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>, material: materialsData | undefined) => {
    event.stopPropagation(); // Stop propagation to prevent triggering parent click
    if (material) {
      setSelectedMaterial(material);
      if (material?.isclassroom === true) {
        setAnchorEl(event.currentTarget);
        setOpenOverlay(true);
      } else if (material?.isclassroom === false) {
        setAction('share');
        setOpenConfirmationPopup(true);
      }
    }
  };

  const handleCloseActions = () => {
    setAnchorEl(null);
    setOpenOverlay(false);
  };
  
  const menuItems = handleMaterialActions ? getMenuItems(handleCloseActions, handleMaterialActions, setOpenConfirmationPopup, setAction, selectedMaterial, isQuestionBank ? "QuestionBank" : ""):[];


    //To check overflow in resize 
    useEffect(() => {
      window.addEventListener('resize', checkOverflow);
  
      return () => {
        window.removeEventListener('resize', checkOverflow);
      };
    }, []);
  
    useEffect(() => {
      checkOverflow();
    }, [material]);
    
  return (
    <>
      <div className={`singleMaterialCardContainer ${isQuestionBank ? 'fullWidthCard mentionedHeight' : ''}`} key={keyValue} onClick={handleClick}>
        <div className='borderStyleContainer'></div>
        <div className={materialData ? 'qsBankTextStyle' : 'textstyle'}>
          <Tooltip title={conditionalMaterialName()} disableHoverListener={!isOverflow}>
            <div className='materialOverflowStyle' ref={materialTitleRef} onMouseEnter={checkOverflow}>{conditionalMaterialName()}</div>
          </Tooltip>
          {(handleOpenFile && ((role === TEACHER_ROLE  && !materialData?.sharedBy)|| role === SCHOOL_ADMIN) ) && 
          <div className="singleMaterialCardBtn" onClick={(event) => handleClickMoreIcon(event, materialData)} >
            {materialData?.isclassroom ?
              <img src={greyMoreIcon} alt="action" className='moreIcon'/> :
              <img src={ShareIcon} alt="share" className='shareIcon'/>
            }
          </div>}
         {(handleOpenFile && (((role === TEACHER_ROLE || role === STUDENT_ROLE) && materialData?.sharedBy)) ) && 
          <div className="singleMaterialCardBtn"  >
           <div className='Admin-label'>{BY_ADMIN}</div>
          </div>}
          {
            (role === STUDENT_ROLE && materialData?.status === 'COMPLETED') && 
            <div className="singleMaterialCardBtn">
                <label className="scoreLabel">{`Your Score:`}</label>
                <span><label className='scoreValue'>{`${materialData?.totalScore}/${materialData?.totalQuestions}`}</label></span>
            </div>
          }
        </div>
        {( active) && <img src={redDotImage} className='redDotStyle' alt='redDotIcon'/>}
      </div>
      <MaterialActionsOverlay
        anchorEl={anchorEl}
        open={openOverlay}
        handleClose={handleCloseActions}
        menuItems={menuItems}
        actionsHeight={'106px'}
        position="left"
      />
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={action==="share" ?  confirmationMessageShare: confirmationMessageDelete}
        gifData={action === "share" ? ShareGif : DeleteGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'210px'}
      />
    </>
  )
}

export default SingleMaterialCard;
